import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetSearchRefund, GetSearchRefundModel, GetSearchRefundParams} from 'domain/usecases';

export class RemoteGetSearchRefund implements GetSearchRefund {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetSearchRefundModel>,
	) {}

	async get(params: GetSearchRefundParams): Promise<GetSearchRefundModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
